import { useContext } from "react";
import "./style.css";
import { ContextGlobal } from "../../context";

function Footer() {
	const { appVersion } = useContext(ContextGlobal);
	const ano = new Date().getFullYear();

	//row ocupa a largura toda da tela
	return (
		<div className="row footer border-top mt-3">
			<div className="col-12 text-center ">
				<p className="copyright">
					© {ano} - SZ Sistemas Todos os direitos reservados. Versão {appVersion}
				</p>
			</div>
		</div>
	);
}

export default Footer;
